import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeNotesRoute extends Route {
  @service store;
  @service currentUser;

  async model() {
    const initiative = this.modelFor('backlog.initiatives.initiative');
    let bon = await initiative.bon;

    if (!bon)
      bon = this.store.createRecord('bon', {
        initiative,
      });
    return bon;
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeNotesRoute,
);
